import { render } from "./TransactionTabs.vue?vue&type=template&id=222c2ebe&scoped=true"
import script from "./TransactionTabs.vue?vue&type=script&lang=js"
export * from "./TransactionTabs.vue?vue&type=script&lang=js"

import "./TransactionTabs.vue?vue&type=style&index=0&id=222c2ebe&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222c2ebe"]])

export default __exports__